import React from 'react'
import { Breadcrumbs } from '@/components/ui/breadcrumb'
import { getTicketComplianceFields } from 'components/Filter/TicketFields'
import { links } from 'utils/featureToggles'

import Tickets from './Tickets/Tickets'
import { ticketsComplianceColumn } from './ticketsComplianceColumn'
import { TicketsViewType } from './TicketsViewType'

const TicketsCompliance = (): JSX.Element => (
  <React.Fragment>
    <Breadcrumbs crumbs={[{ title: 'Compliance Tickets', link: links.ticketsCompliance.url }]} />
    <Tickets
      viewType={TicketsViewType.Compliance}
      columns={ticketsComplianceColumn}
      filterFields={getTicketComplianceFields}
    />
  </React.Fragment>
)

export default TicketsCompliance
